import styled from "styled-components"
import theme from "styles/theme-main"

export const ErrorMessage = styled.div`
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  margin-left: 0;
  margin-top: 0;
`

export const Row = styled.div`
  display: flex;
  margin-bottom: 10px;
  align-items: center;
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  pointer-events: ${props => (props.disabled ? "none" : "inherit")};
`

export const Label = styled.label`
  margin-left: ${props => (props.labelMargin ? "20px" : "9px")};
  line-height: 24px;
  font-size: 16px;
  font-weight: 400;
  color: ${props =>
    props.labelColour ? props.labelColour : theme.colors.textPrimary};

  a {
    display: inline-block;
    text-decoration: none;
    padding-bottom: 1px;
    color: inherit;
    border-bottom: 1px dotted;
    transition: color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  }

  a:hover {
    color: inherit;
  }
`

export const Wrapper = styled.div`
  width: 30px;
  min-width: 30px;
  max-width: 30px;
  height: 30px;
  color: ${props =>
    props.value ? props.theme.colors.primary : props.theme.colors.border};
  background-color: ${props => (props.whiteBG ? "white" : "transparent")};
`
